module.exports = __webpack_public_path__ + "static/transparency-9af7cac826d2b14ab6dcad6e4ff2ccd1.png";